import {useEffect, useState} from 'react';
import {useOktaAuth} from '@okta/okta-react'

const ciEquals = (a: string, b: string) => {
    return a && b && a.localeCompare(b, undefined, {sensitivity: 'base'}) === 0;
}

export default function useRoleManagement() {
    const [roles, setRoles] = useState({roles: []});
    const oktaAuth = useOktaAuth();
    const authState = oktaAuth?.authState;
    const isAuthenticated = authState?.isAuthenticated;
    const token = authState?.accessToken?.accessToken;

    useEffect(() => {
        const baseUrl = process.env.REACT_APP_ROLE_MANAGEMENT_BASE_URL
            ?? (() => {
                console.log("No baseUrl found, setting default ...");
                return "https://api.eu.customs-inventory-test.nikecloud.com/role/list";
            })();

        const fetchRoles = async () => {
            if (!isAuthenticated) {
                return;
            }
            console.log("Fetching roles from ", baseUrl);
            setRoles(await fetch(baseUrl, {
                method: "GET",
                headers: {
                    "accept": "application/json",
                    "authorization": "Bearer " + token
                }
            }).then(response => response.json()));
        }

        fetchRoles();
    }, [setRoles, isAuthenticated, token]);

    return {
        roles: roles.roles,
        hasRole: (role: string) => {
            if (roles && role) {
                for (const r of roles.roles) {
                    if (ciEquals(r, role)) {
                        return true;
                    }
                }
            }
            return false;
        }
    };
}